import { Observable } from 'rxjs';
import { Access, CreateAccessPayload } from './model';
import { Invitation, LinkedCompany, FiscalAlert, OfflineClientPayload } from '../../types/accountant';
import { ApiResponse } from '../common/api-response';

export abstract class SharedAccountsRepository {
  abstract getAccesses(page: number, limit: number): Observable<ApiResponse<{ data: Access[], total: number }>>;
  abstract createAccess(access: CreateAccessPayload): Observable<ApiResponse<Access>>;
  abstract deleteAccess(id: number): Observable<ApiResponse<void>>;
  abstract getGrantedAccesses(page: number, limit: number): Observable<ApiResponse<{ data: Access[], total: number }>>;
  abstract createCollaborator(payload: { name: string, email: string }): Observable<ApiResponse<Access>>;

  // Accountant Hub specialized methods
  abstract acceptInvitation(id: number): Observable<ApiResponse<void>>;
  abstract inviteAccountant(email: string): Observable<ApiResponse<Invitation>>;
  abstract getAccountantInvitations(): Observable<ApiResponse<Invitation[]>>;
  abstract getAccountantLinkedCompanies(): Observable<ApiResponse<{ data: LinkedCompany[], total: number }>>;
  abstract getFiscalAlerts(): Observable<ApiResponse<FiscalAlert[]>>;
  abstract healGaps(companyId: number): Observable<ApiResponse<any>>;
  abstract createOfflineClient(payload: OfflineClientPayload): Observable<ApiResponse<Access>>;
}
